// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class NearFieldAnalysisGuidanceCatalog {
    static NearFieldAnalysisOverviewModule: IGuidanceTopic = {
        name: "NearFieldAnalysis_Overview",
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/Overview.html"),
        title: "Near Field Analysis",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Near Field Analysis Help",
    };
    static NearFieldAnalysisGS1Module: IGuidanceTopic = {
        name: "NearFieldAnalysis_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720241040/NF1+How+do+I+use+Near+Field+analysis
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/NF1HowDoIUseNearFieldAnalysis.html"),
        title: "Near Field Analysis",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicParent: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How do I use Near Field analysis?",
        catchwords: ["Holography"],
    };
    static NearFieldAnalysisGS2Module: IGuidanceTopic = {
        name: "NearFieldAnalysis_Q2", // https://sorama.atlassian.net/wiki/spaces/UI/pages/807895415/NF2+How+does+Near+Field+analysis+work
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/NF2HowDoesNearFieldAnalysisWork.html"),
        title: "Near Field Analysis",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicParent: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How does Near Field analysis work?",
        catchwords: ["Holography"],
    };
    static NearFieldAnalysisGS3Module: IGuidanceTopic = {
        name: "NearFieldAnalysis_Q3",
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/NF3WhatIsNearField.html"),
        title: "Near Field Analysis",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicType: GuidanceTopicType.TopicOverview,
        topicParent: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        topicContent: "What is Near Field Analysis?",
    };
    static NearFieldAnalysisGS5Module: IGuidanceTopic = {
        name: "NearFieldAnalysis_Q5", //https://sorama.atlassian.net/wiki/spaces/UI/pages/825491673/NF5+Quick+start+for+using+the+Near+Field+analysis
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/NF5NearfieldQuickStart.html"),
        title: "Near Field Quick Start",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicType: GuidanceTopicType.TopicOverview,
        topicParent: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        topicContent: "Near Field Quick Start",
    };
    static NearFieldAnalysisGS6Module: IGuidanceTopic = {
        name: "NearFieldAnalysis_Q6",
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/NF6FrequencyBoundariesForNearFieldAnalysis.html"),
        title: "What are the frequency boundaries for Near Field analysis?",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicType: GuidanceTopicType.TopicOverview,
        topicParent: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        topicContent: "What are the frequency boundaries for Near Field analysis?",
    };
    static NearFieldAnalysisGS7Module: IGuidanceTopic = {
        name: "NearFieldAnalysis_Q7",
        modulePath: PLATFORM.moduleName("guidance/NearFieldAnalysis/NF7NearfieldDistanceSetting.html"),
        title: "Near Field Distance Setting",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoMeasurementAnalysis),
        topicType: GuidanceTopicType.TopicOverview,
        topicParent: NearFieldAnalysisGuidanceCatalog.NearFieldAnalysisOverviewModule,
        topicContent: "Near Field Distance Setting",
    };
}
